module.exports = ".advantage-wrapper {\n  text-align: left; }\n"